var _excluded = ["reviewProfile"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { FacebookIcon, LinkIcon, InstagramIcon, LinkedinIcon, EmailIcon } from '@domain-group/fe-co-icon';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { AverageStarRatingAndTotal } from '@domain-group/fe-co-allhomes-average-star-rating-and-total';
import { Button, CallButton } from '@domain-group/fe-co-allhomes-design-system';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import { AgentAwardPill } from '@domain-group/fe-co-allhomes-shared-components';
import { AgencyDetails } from './agency-details';
import * as styles from './agent-card-header.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentCardHeader = _ref => {
  var _props$highlightedAwa, _props$highlightedAwa2;
  var reviewProfile = _ref.reviewProfile,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var mobile = props.media.mobile;
  var isPlatinum = props.brandingLevel === 'PLATINUM';
  var socialIcon = (Icon, target, eventName) => target ? ___EmotionJSX("a", {
    href: target,
    onClick: () => sendEvent("social.".concat(eventName, "-click")),
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": eventName
  }, ___EmotionJSX("div", {
    css: styles.socialIcon
  }, ___EmotionJSX(Icon, null))) : undefined;
  var handleEmailClick = () => {
    sendEvent('email-click');
    props.onEmailClick();
  };
  return ___EmotionJSX("div", {
    css: styles.container
  }, toggledFeatures[ToggledFeatureKey.FIND_AN_AGENT_PACKAGE_BRANDING] && mobile && isPlatinum && ___EmotionJSX(AgencyDetails, {
    appearance: "premium",
    agencyLogo: props.agencyLogo,
    agencyProfileUrl: props.agencyProfileUrl,
    agencyLogoBackgroundColour: props.agencyLogoBackgroundColour,
    title: props.title
  }), ___EmotionJSX(Avatar, {
    css: styles.avatar,
    imageUrl: props.profilePhoto,
    imageTitle: props.name,
    shape: "circle",
    colorScheme: "dark"
  }), mobile ? ___EmotionJSX(Fragment, null, ___EmotionJSX("h1", {
    css: styles.name
  }, props.name), props.jobTitle && ___EmotionJSX("h2", {
    css: styles.jobTitle
  }, props.jobTitle)) : ___EmotionJSX(Fragment, null, ___EmotionJSX("h2", {
    css: styles.name
  }, props.name), props.jobTitle && ___EmotionJSX("h3", {
    css: styles.jobTitle
  }, props.jobTitle)), ((_props$highlightedAwa = props.highlightedAwards) === null || _props$highlightedAwa === void 0 ? void 0 : _props$highlightedAwa.length) > 0 && ___EmotionJSX("div", {
    css: styles.pills
  }, (_props$highlightedAwa2 = props.highlightedAwards) === null || _props$highlightedAwa2 === void 0 ? void 0 : _props$highlightedAwa2.map(award => ___EmotionJSX(AgentAwardPill, {
    label: award.badgeLabel
  }))), toggledFeatures[ToggledFeatureKey.FIND_AN_AGENT_PACKAGE_BRANDING] && (reviewProfile === null || reviewProfile === void 0 ? void 0 : reviewProfile.reviewCount) > 0 && ___EmotionJSX(AverageStarRatingAndTotal, {
    size: "m",
    averageRating: reviewProfile.overallRating,
    totalReviews: reviewProfile.reviewCount
  }), ___EmotionJSX("div", {
    css: styles.socials
  }, socialIcon(LinkIcon, props.websiteUrl, 'website'), socialIcon(FacebookIcon, props.facebookUrl, 'facebook'), socialIcon(InstagramIcon, props.instagramUrl, 'instagram'), socialIcon(LinkedinIcon, props.linkedinUrl, 'linkedin')), mobile && (!toggledFeatures[ToggledFeatureKey.FIND_AN_AGENT_PACKAGE_BRANDING] || !isPlatinum) && ___EmotionJSX(AgencyDetails, {
    agencyLogo: props.agencyLogo,
    agencyProfileUrl: props.agencyProfileUrl,
    agencyLogoBackgroundColour: props.agencyLogoBackgroundColour,
    title: props.title
  }), !mobile && ___EmotionJSX("div", {
    css: styles.buttonGroupContainer
  }, ___EmotionJSX("div", {
    css: styles.buttonGroup,
    "data-test-id": "button-group"
  }, ___EmotionJSX(CallButton, {
    phone: props.phoneNumber
  }), props.isEmailContactable && ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(Button, {
    appearance: "primary",
    css: styles.emailButton,
    icon: ___EmotionJSX(EmailIcon, null),
    onClick: handleEmailClick
  }, "Email")))));
};
AllhomesAgentCardHeader.propTypes = {
  name: PropTypes.string.isRequired,
  profilePhoto: PropTypes.string,
  agencyLogo: PropTypes.string,
  agencyLogoBackgroundColour: PropTypes.string,
  jobTitle: PropTypes.string,
  // title is actually agency name:
  title: PropTypes.string,
  websiteUrl: PropTypes.string,
  phoneNumber: PropTypes.string,
  isEmailContactable: PropTypes.bool,
  agencyProfileUrl: PropTypes.string,
  facebookUrl: PropTypes.string,
  instagramUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  onEmailClick: PropTypes.func.isRequired,
  highlightedAwards: PropTypes.arrayOf(PropTypes.shape({
    badgeLabel: PropTypes.string.isRequired
  })),
  media: PropTypes.shape({
    desktop: PropTypes.bool,
    tablet: PropTypes.bool,
    mobile: PropTypes.bool
  }),
  reviewProfile: PropTypes.shape({
    overallRating: PropTypes.number.isRequired,
    reviewCount: PropTypes.number.isRequired
  }).isRequired,
  brandingLevel: PropTypes.oneOf(['GOLD', 'PLATINUM', 'CASUAL'])
};
AllhomesAgentCardHeader.defaultProps = {
  profilePhoto: '',
  agencyLogo: undefined,
  agencyLogoBackgroundColour: undefined,
  title: undefined,
  jobTitle: '',
  websiteUrl: '',
  phoneNumber: '',
  isEmailContactable: true,
  agencyProfileUrl: '',
  highlightedAwards: [],
  media: {},
  facebookUrl: undefined,
  instagramUrl: undefined,
  linkedinUrl: undefined,
  brandingLevel: 'CASUAL'
};
export default withMedia(AllhomesAgentCardHeader);
export { AllhomesAgentCardHeader as BaseAllhomesAgentCardHeader };